import { Component } from '@angular/core';

@Component({
  selector: 'white-card',
  templateUrl: './white-card.component.html',
  styleUrls: ['./white-card.component.scss']
})
export class WhiteCardComponent {

}
